// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"86":"932e8201","174":"6cdb7e35"}[chunkId] + ".chunk.js";
};